import { Component, Fragment, h, Host, Prop } from '@stencil/core';
import { appRouter } from '../../../global';

@Component({
  tag: 'entry-working-from-home',
  styleUrl: 'component.css',
  assetsDirs: ['../assets'],
  shadow: true,
})
export class EntryWorkingFromHomePage {

  @Prop({ reflect: true }) summary: boolean = false;

  render() {
    return <Host class="article"
      {...(this.summary && appRouter.click.workingFromHome())}
    >
      <div class="heading content box">
        <h2>Working From Home</h2>
        <time class="aside">3 Aug 12</time>
      </div>

      <div class="body content">
        <blockquote class="hero-background">
          <h3 class="sub-sub-heading">this, from my blog 10 years ago</h3>
          <p>I have worked from home since then and all of this holds true, bar some of the tech</p>
          <p>Its interesting to see so many people now finding the same benefits and freedoms while still providing employers with the things they need</p>
          <p>Anyway, time flies, seems like yesterday ...</p>
        </blockquote>
      </div>

      {this.summary
        ? <div class="body content box">
          <noscript class="right"><a {...appRouter.href.workingFromHome()}>read more &hellip;</a></noscript>
        </div>
        : this.renderMore()}

    </Host>;
  }

  renderMore() {

    return <Fragment>

      <section>
        <div class="body content">
          <p>
            For nearly two years now I have been working from home, it has been an experience which I have enjoyed and has brought benefits for my employer too (that would be you if you employed me).
          </p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>no office space required</h3>
        </div>
        <div class="body content">
          <p>I have contracted for a number of companies over the years, some have dedicated teams for managing the office space and some not, its not unusual to turn up for my first day of work and have nowhere to sit</p>

          <p>At home I have my space organised, I have my own office separate from the rest of the house (and kids). I have a big desk and Herman to sit on, and on my first day I am ready to go - no faf</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>no hardware required</h3>
        </div>
        <div class="body content">
          <p>As above, its not unusual for a new person to be lacking the necessary equipment on their first day. As a programmer, I need a pretty high-end beast of a computer for my employer to get the best out of me</p>

          <p>At home I have a spanky i7 8 core monster, 8 GB of memory and a system SSD. I have 3 monitors and my iPad to watch the news on. I don't need you to buy me anything</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>no software licences required</h3>
        </div>
        <div class="body content">
          <p>This is the biggest problem, in my experience, a developers toolbox now-a-days is quite heavy and expensive</p>

          <p>As a C# Developer, I need</p>
          <ul>
            <li>Windows - duh</li>
            <li>Visual Studio, at least Pro</li>
            <li>Resharper, its developer heroine, I can't go cold turkey, its too late</li>
            <li>Graphics software, I must draw icons occasionally</li>
            <li>E-mail, spreadsheet and document software</li>
          </ul>
          <p>At home I have all of this and much more, I get my Action Pack every year and its full of goodies. What is more I am already set-up, you won't lose a day of programming while I watch a tracker bar</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>no late to meetings because of train delays</h3>
        </div>
        <div class="body content">
          <p>Every morning I have a meeting with all my colleagues in London, the Isle of Man, Russia and India. Its a magical Skype chat, everyone has a coffee or tea etc, and we all find out what we did yesterday and what we are going to do today (Stand-up)</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>day-to-day communication is easier</h3>
        </div>
        <div class="body content">
          <p>During the day, I am available at the drop of a hat for a chat</p>

          <p>We have organised meetings too, I just get myself a cuppa and click a button to start planning the next sprint or whatever</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>pair programming is easier</h3>
        </div>
        <div class="body content">
          <p>One of the real revelations for me has been screen sharing, we had used Skype, but more recently we have moved to join.me for this</p>

          <p>You can pair program without having to look at the back of your colleagues head or get his/her mouse covered in the contents of your doughnut</p>
        </div>
      </section>

      <section>
        <div class="sub-heading content">
          <h3>other things</h3>
        </div>
        <div class="body content">
          <p>I do like a bit of mood music, but this will not disturb you, unless you move next door that is...</p>

          <p>I won't upset your office manager by not wearing a tie, or only wearing a tie</p>

          <p>The best programmer for your job is not necessarily going to be the one who can get on the 7:01 to Paddington</p>
        </div>

        <div class="body content">
          <img class="hero" src="/assets/coding-cat.webp" width="1024" height="585" title="AI Image. A steam punk brown Siberian cat riding a chopper bike, with goggles, smiling and waving his paws in the air like he just don't care, with sparks, neon and electric cables on the bike, plenty of sky. The bike has a large engine, a skull-shaped headlight, and a flame-shaped exhaust. The background is a blue sky with clouds and birds. The image has a retro-futuristic style, with contrast, saturation, and glow effects. The image is also more moody, smokey, and has some neon tubes on the bike." />
        </div>
      </section>
    </Fragment>
  }
}
